import Button from "./Button";

function Banner(props){
    return(
        <section className="vanner">
            <h1 className="head-1">{props.title}</h1>
            <p>{props.text}</p>
            <div>
                <Button text="Learn More" type="primary" />
                <Button text="Login" type="secondary" />
            </div>

        </section>
    );
}

export default Banner;